import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const TIERS = [
  { key: 'intimate', highlighted: false },
  { key: 'signature', highlighted: true },
  { key: 'editorial', highlighted: false },
];

function Collections(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div id="collections" className="lf-bg-tint lf-section-anchor">
      <div className="lf-editorial lf-section py-5">
        <div className="lf-reveal" style={{ maxWidth: '40rem' }}>
          <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.22, letterSpacing: '-0.04em' }}>
            {floral.pricing.title[language]}
          </h2>
          <p className="mt-3" style={{ color: 'var(--lf-muted)', lineHeight: 1.55 }}>
            {floral.pricing.description[language]}
          </p>
        </div>
        <div className="row mt-4">
          {TIERS.map((tier) => {
            return (
              <div className="col-md-4 mb-3 lf-reveal" key={tier.key}>
                <div className={`lf-card${tier.highlighted ? ' is-signature' : ''}`} style={{ height: '100%' }}>
                  <p className="lf-eyebrow" style={{ marginBottom: '1.2rem' }}>{floral.pricing.startingFrom[language]}</p>
                  <h3 className="lf-display" style={{ fontSize: '1.72rem' }}>{floral.pricing[tier.key].title[language]}</h3>
                  <p className="mt-4" style={{ fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
                    {floral.pricing[tier.key].price[language]}
                  </p>
                  <p className="mt-3" style={{ fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--lf-muted)', whiteSpace: 'pre-wrap' }}>
                    {floral.pricing[tier.key].text[language]}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-3 lf-reveal">
          <a
            className="lf-btn-primary"
            style={{ color: '#fff' }}
            onClick={() => {
              const target = document.getElementById('contact');
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            {floral.pricing.requestQuote[language]}
          </a>
        </div>
      </div>
    </div>
  );
}

export { Collections };
